<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { UISwitch, UITooltip } from "@gohighlevel/ghl-ui";
import { debounce } from "lodash";
import { useI18n } from "vue-i18n";

import questionIcon from "@/assets/icons/question-icon.svg";

const props = defineProps({
  selectedIndex: {
    type: Number,
    required: true,
  },
  selectedSlideIndex: {
    type: Number,
    required: false,
    default: undefined,
  },
});

const { t } = useI18n();
const store = useAppStore();

const toggleAutoComplete = debounce((value) => {
  store.addressSettings.autoCompleteEnabled = value;

  // if auto complete is disabled, then set the required field to false
  if (!value) {
    if (props.selectedSlideIndex !== undefined) {
      store.slides[props.selectedSlideIndex].slideData[props.selectedIndex].required = value;
    } else {
      store.elements[props.selectedIndex].required = value;
    }
  }

  store.addToHistory();
  store.anyUnsavedChanges = true;
}, 10);
</script>

<template>
  <div class="flex justify-between py-2">
    <div class="flex items-center gap-1">
      <div class="switch-handle my-auto text-base">
        {{ t("common.addressSettings.autoComplete") }}
      </div>
      <UITooltip>
        <template #trigger>
          <questionIcon></questionIcon>
        </template>
        {{ t("common.addressSettings.autoCompleteTooltip") }}
      </UITooltip>
    </div>
    <div class="switch">
      <UISwitch
        size="small"
        :value="store.addressSettings.autoCompleteEnabled"
        :disabled="false"
        @update:value="toggleAutoComplete"
      />
    </div>
  </div>
</template>
